import { ApiState } from "../../common/constants/api-constants";

export declare interface CountryStateSelectState {
  selectedCountryState: { [key: string]: string };
  countryStateResponse: GetCountryStateResponseState;
}

export declare interface GetCountryStateResponseState extends ApiState {
  data: { [index: string]: string };
}

export declare interface FetchStateRequest {
  type: string;
  countryCode: string;
}

export enum CountryCode {
  US = "US",
  CA = "CA"
}

export declare interface AvailableCountryRegionMagento {
  id: string;
  code: string;
  name: string;
}
